import { useLocation, useNavigate } from 'react-router-dom';
import Wrong from '@assets/wrong.svg';
import {
  ErrorCode, ClaimType, dhgate, PLATFORM_NAME, SHOPLINE,
} from '@constants';
import {
  Note, SeelEmail, Button, BackButton, ContinueButton,
} from '@components';
import { useSelector } from 'react-redux';

const getText = (type, specialPlatform) => {
  if (specialPlatform === SHOPLINE && [ClaimType.Delay, ClaimType.Damage, ClaimType.Theft, ClaimType.Loss].includes(type)) {
    return 'Delivery Guarantee';
  }
  switch (type) {
    case ClaimType.RA: return 'Return Assurance';
    case ClaimType.EW: return 'Product Protection';
    case ClaimType.AD: return 'Product Protection';

    default:
      return 'Shipping Protection';
  }
};
const unauthorizeText = (platform) => {
  const textMap = {
    [dhgate]: 'It appears there was an issue validating your credentials. Please go back to your DHgate order details page and click on the link again to retry.',
    [PLATFORM_NAME.SHOPSHOPS]: 'It appears there was an issue validating your credentials. Please return to the login page by clicking the back button below, or your order details page on ShopShops, and try clicking the link again.',
  };
  return textMap[platform];
};

export const ErrorPage = ({ code }) => {
  const { state } = useLocation();
  const { platform, specialPlatform } = useSelector((state) => state.policy);
  const navigate = useNavigate();
  const errCode = state?.code || code || ErrorCode.Wrong;
  const message = state?.message && `${state.message} Should you have any questions, please contact us at`;
  const backStep = state?.backStep;
  let notShowButton = state?.notShowButton;
  if (errCode === ErrorCode.Unauthorized && platform === dhgate) {
    notShowButton = true;
  }
  const claimId = state?.claimId;
  const backHome = () => navigate(`/${platform}`);
  const text = getText(state?.type, specialPlatform);
  const orderOrProduct = [ClaimType.EW, ClaimType.AD].includes(state?.type) ? 'product' : 'order';
  const notShowEmail = [ErrorCode.Unauthorized, ErrorCode.Blacklist].includes(errCode);
  const ErrorText = {
    [ErrorCode.Wrong]: 'Something went wrong, and your submission failed. \nPlease try again later. Should you have any questions, please contact us at',
    [ErrorCode.Expired]: `${text} for this ${orderOrProduct} has expired. No more issues can be reported. Should you have any questions, please contact us at`,
    [ErrorCode.Total]: `The total payout for this ${orderOrProduct} has already reached the total value paid for the purchased item(s). No more issues can be reported. Should you have any questions, please contact us at`,
    [ErrorCode.Refresh]: 'Session expired. Please log in again.',
    [ErrorCode.WrongRequest]: 'Something went wrong with this request. Please contact at',
    [ErrorCode.Cancelled]: `${text} for this ${orderOrProduct} has been canceled. No more issues can be reported. The cancellation is probably due to the cancellation of your ${orderOrProduct}, or the merchant’s refund of your ${text} fee. Should you have any questions, please contact us at`,
    [ErrorCode.HasOldClaim]: "You've already submitted the issue. The issue is being processed or has already been processed. If you have any questions, please contact",
    [ErrorCode.CoverdItemEmpty]: 'Something went wrong with your cover. Please contact us at',
    [ErrorCode.Nothing]: `No Seel covers found for this ${orderOrProduct}. Please double check or contact us at`,
    [ErrorCode.Unfulfilled]: 'You can\'t report a package issue when your order hasn\'t been fulfilled yet. Should you have any questions, please contact us at',
    [ErrorCode.PolicyNotActive]: 'You can\'t report a package issue when your order hasn\'t been fulfilled yet. Should you have any questions, please contact us at ',
    [ErrorCode.Unauthorized]: unauthorizeText(platform),
    [ErrorCode.HasDelay]: 'An issue of delay has already been reported for this package.',
    [ErrorCode.Instant]: 'It is not yet time to file a report. Please try again after 48 hours. Should you have any questions, please contact us at',
    [ErrorCode.SpecialCodeForCTBids]: 'Since there is no tracking information available on Day 29, filling a claim is not currently possible. Should you have any questions, please contact us at',
    [ErrorCode.Blacklist]: 'We apologize, but we are unable to issue any payouts for this order. The protection fee paid to ParcelPanel for your order was not reemitted to Seel, and as a result, the coverage has been canceled and our service with them has been discontinued. We are truly sorry for the inconvenience to you, and recommend contacting the merchant directly to ensure your issue is resolved.',
  };

  if (errCode === ErrorCode.Refresh) {
    return (
      <Note
        icon={Wrong}
        title="Oops!"
        subTitle={ErrorText[errCode]}
        hasBackBtn={false}
      >
        <Button
          onClick={backHome}
          style={{
            background: '#fff',
            border: '1px solid #BABFC3',
            borderRadius: '2px',
            color: '#202223',
            padding: '8px 16px',
            boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
          }}
        >
          Log in
        </Button>
      </Note>
    );
  }

  // 针对dhgate delay，当同一个包裹申请过后，就强制不让继续申请
  if (errCode === ErrorCode.HasDelay) {
    return (
      <Note
        icon={Wrong}
        title="Sorry"
        hasBackBtn={false}
      >
        <section style={{ marginBottom: '24px' }}>
          <span>{ErrorText[errCode]}</span>
        </section>
        <section>
          <BackButton showIcon={false} />
          <ContinueButton text="View issue" showIcon={false} onClick={() => navigate(`../feedback?claimId=${claimId}`)} />
        </section>
      </Note>
    );
  }

  return (
    <Note
      icon={Wrong}
      title="Sorry"
      hasBackBtn={!notShowButton}
      backStep={backStep}
    // navigateUrl={`/${platform}`}
    >
      <section style={{ marginBottom: '24px' }}>
        <span>{errCode === ErrorCode.Conflict ? message : ErrorText[errCode]}</span>
        {!notShowEmail && (
          <>
            <SeelEmail style={{ marginLeft: '8px' }} />
            <span>.</span>
          </>
        )}

      </section>
    </Note>
  );
};
